import * as React from "react";
import { Row } from "components/bootstrap";
import PageNavigation from "components/common/PageNavigation";
export const PAGE_NAVIGATION_TITLE = "AI Agent Workflows";
export const WORKFLOWS_TITLE = "Workflows";
export const RUNS_TITLE = "Runs";
export const USAGE_TITLE = "Usage";
export const SETTINGS_TITLE = "Settings";
const AgentWorkflowPageNavigation = () => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAVIGATION_TITLE }));
export default AgentWorkflowPageNavigation;
